import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import "./UserList.css";

const VideosList = () => {
    document.title = "Videos | Uma Classes";

    const [videos, setvideos] = useState([]);
    const [modal, setModal] = useState(false);
    const [voiceIdToDelete, setVoiceIdToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchvideos = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('https://uma.aasmo.in/api/admin/getall-videos', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setvideos(response || []); // Ensure you are accessing the data property
            } catch (error) {
                console.error('Error fetching videos:', error);
            }
        };

        fetchvideos();
    }, []);

    const toggleModal = () => setModal(!modal);

    const handleDelete = (voiceId) => {
        setVoiceIdToDelete(voiceId);
        toggleModal();
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`https://uma.aasmo.in/api/admin/delete-video/${voiceIdToDelete}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setvideos(videos.filter(voice => voice._id !== voiceIdToDelete));
            toggleModal();
        } catch (error) {
            console.error('Error deleting voice:', error);
        }
    };

    const handleEdit = (voiceId) => {
        navigate(`/edit-videos/${voiceId}`);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Videos" breadcrumbItem="All" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">All videos</h4>
                                    <p className="card-title-desc">Below are all videos</p>

                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Category</th>
                                                    <th>Subcategory</th>
                                                    <th>Sub-Subcategory</th>
                                                    <th>Title</th>
                                                    <th>Description</th>
                                                    <th>Upload Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {videos.length > 0 ? (
                                                    videos.map((voice, index) => (
                                                        <tr key={voice._id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td className="nowrap">{voice?.category?.name || 'N/A'}</td>
                                                            <td className="nowrap">{voice?.subcategory?.name || 'N/A'}</td>
                                                            <td className="nowrap">{voice?.subSubcategory?.name || 'N/A'}</td>
                                                            <td className="nowrap">{voice?.title || 'N/A'}</td>
                                                            <td className="nowrap">{voice?.description || 'N/A'}</td>
                                                            <td className="nowrap">{moment(voice?.createdAt).format('MMMM Do, YYYY')}</td>
                                                            <td>
                                                                <i className="dripicons-document-edit" onClick={() => handleEdit(voice._id)} title="Edit" />{" "}
                                                                <i className="dripicons-document-delete" onClick={() => handleDelete(voice._id)} title="Delete" />{" "}
                                                                <Link to={voice?.videoUrl}>
                                                                    <i className="dripicons-cloud-download" />
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">No videos found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Delete Confirmation Modal */}
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this voice?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                        <Button color="danger" onClick={confirmDelete}>Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default VideosList;
